export const PRODUCT_FILTER = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  ALL: "all"
};

export default PRODUCT_FILTER;
